/**
 * Shared campaign types used across all campaign variants
 */

export type CampaignTypes = 'tournaments' | 'prize_pop' | 'rebate';

export const CAMPAIGN_LEVELS = {
  GOLD: 'GOLD',
  PURPLE: 'PURPLE',
  RED: 'RED',
  BLUE: 'BLUE',
  GREEN: 'GREEN',
  MADNESS: 'MADNESS',
} as const;

export type CampaignLevel = (typeof CAMPAIGN_LEVELS)[keyof typeof CAMPAIGN_LEVELS];

export interface ICampaignResources {
  CampaignsMultiViewSoloSeparatedBackgroundLandscape?: string;
  CampaignsMultiViewSoloSeparatedBackgroundPortrait?: string;
  CampaignsMultiViewSoloTransparentImage?: string;
  CampaignsMultiViewSoloTransparentImageDesktop?: string;
  CampaignsPlate?: string;
  CampaignsPlateClose?: string;
  CampaignsPlateCloseLogo?: string;
  CampaignsSingleViewSoloBackgroundClose?: string;
  CampaignsSingleViewSoloBackgroundLandscape?: string;
  CampaignsSingleViewSoloBackgroundPortrait?: string;
  FillColor?: string;
  BorderColor?: string;
  [key: string]: string | undefined;
}
